
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/block/[height_or_hash]",
      function () {
        return require("private-next-pages/block/[height_or_hash].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/block/[height_or_hash]"])
      });
    }
  